import React, { useState, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../store/configureStore';
// tracking
import firebase from '@firebase/app';
import '@firebase/analytics';
import { FIREBASE_CONFIG } from '../utils/constants/firebaseConfig';

/**context */
import { AuthContext } from '../context/auth';
import { LocaleContext } from '../context/localization';
/** Utils */
import { getToken } from '../utils/apiConfig';
/** Internal components */
import Toaster from '../components/Toaster';
import Loader from '../components/Loader';
import Portal from './portal';
import Public from './public';
import Consigner from './consigner';
import WebViews from './webViews';
import SnackBar from '../components/UI/HOC/SnackBar';
import withClearCache from '../components/UI/HOC/ClearCache/ClearCache';

import { getLocale } from '../utils/apiConfig';
import { Spinner } from 'bohr-web';

const Routes = () => {
  const existingTokens = getToken();
  const locale = getLocale();
  const [authTokens] = useState(existingTokens);

  firebase.initializeApp(FIREBASE_CONFIG);
  firebase.analytics();
  return (
    <Provider store={store}>
      <Suspense fallback={<Spinner width="4rem" thickness="0.2rem" color="blue" fullscreen="true" />}>
        <AuthContext.Provider value={authTokens}>
          <SnackBar />
          <Switch>
            <Route path="/portal/consigner" component={Consigner} />
            <Route path="/portal" component={Portal} />
            <Route path="/public" component={Public} />
            <LocaleContext.Provider value={locale}>
              <Route path="/web-view" component={WebViews} />
            </LocaleContext.Provider>
          </Switch>
          <Toaster />
          <Loader />
        </AuthContext.Provider>
      </Suspense>
    </Provider>
  );
};

export default withClearCache(Routes);
